import {
  ILatestNotification,
  IModifyNotification,
  INoticeAccess,
  INoticeItem,
  INoticePermission,
  INoticeWriter,
  INoticePresignResponse,
  INoticeWriters,
  INotification,
} from '@dataTypes/notificationTypes';
import axios from 'axios';
import { instance } from './index';

export const getNotificationStatus = async (): Promise<INotification> => {
  const response = await instance.get('/user/popup');
  return response.data;
};

export const noShowNotificationForAWeek = async (popupId: number): Promise<boolean> => {
  const response = await instance.post(`/user/popup/expiration/${popupId}`);
  return response.data;
};

export const latestNotification = async (): Promise<ILatestNotification> => {
  const response = await instance.get(`/master/popup/latest`);
  return response.data;
};

export const registerNotification = async (
  data: IModifyNotification,
): Promise<{ success: boolean }> => {
  const response = await instance.post(`/master/popup`, data);
  return response.data;
};

export const modifyNotification = async (
  popupId: number,
  data: IModifyNotification,
): Promise<{ success: boolean }> => {
  const response = await instance.put(`/master/popup/${popupId}`, data);
  return response.data;
};

export const deleteNotification = async (popupId: number): Promise<{ success: boolean }> => {
  const response = await instance.delete(`/master/popup/${popupId}`);
  return response.data;
};

export const getNoticeAccess = async (): Promise<INoticeAccess> => {
  const response = await instance.get('/notice/access');
  return response.data;
};

export const getNoticeList = async (): Promise<INoticeItem[]> => {
  const response = await instance.get('/notice');
  return response.data;
};

export const saveNotice = async (data: IModifyNotification): Promise<{ success: boolean }> => {
  const response = await instance.post('/notice', data);
  return response.data;
};

export const updateNotice = async (
  popupId: number,
  data: IModifyNotification,
): Promise<{ success: boolean }> => {
  const response = await instance.put(`/notice/${popupId}`, data);
  return response.data;
};

export const uploadNoticeImage = async (file: File): Promise<string> => {
  try {
    const presign = await instance.post<INoticePresignResponse>('/master/popup/upload/presign', {
      contentType: file.type,
      filename: file.name,
    });
    const headers = new Headers();
    Object.entries(presign.data.headers || {}).forEach(([key, value]) => headers.set(key, value));
    const method = (presign.data.httpMethod || 'PUT').toUpperCase();
    const uploaded = await fetch(presign.data.uploadUrl, { method, body: file, headers });
    if (!uploaded.ok) {
      throw new Error('이미지 업로드에 실패했습니다.');
    }
    return presign.data.publicUrl;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || '이미지 등록에 실패했습니다.');
    }
    throw error instanceof Error ? error : new Error('이미지 등록에 실패했습니다.');
  }
};

export const deleteNotice = async (popupId: number): Promise<{ success: boolean }> => {
  const response = await instance.delete(`/notice/${popupId}`);
  return response.data;
};

export const getNoticeWriters = async (): Promise<INoticeWriters> => {
  const response = await instance.get('/notice/writers');
  return response.data;
};

export const grantNoticeWriter = async (loginId: string): Promise<INoticeWriter> => {
  const response = await instance.post('/notice/writers', { loginId });
  return response.data;
};

export const revokeNoticeWriter = async (userId: number): Promise<{ success: boolean }> => {
  const response = await instance.delete(`/notice/writers/${userId}`);
  return response.data;
};

export const updateNoticeWriterPermissions = async (
  userId: number,
  data: INoticePermission,
): Promise<INoticeWriter> => {
  const response = await instance.put(`/notice/writers/${userId}`, data);
  return response.data;
};
